import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getFactoryCarLotDiscount(carlotSelected = [], modelSelected = []) {
    let query = ''

    carlotSelected.forEach(carLot => {
        query = query + `car_lot_id[]=${carLot}&`
    })

    modelSelected.forEach(model => {
        query = query + `model_id[]=${model}&`
    })
  
    query = query.slice(0, -1)
    const response = await axios(
        `${REACT_APP_API}/bonifications/conventional/summary?${query}`
    )
    return response?.data?.data[0]
}
